import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HorizonRatingsActions } from './horizon-ratings.actions';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { DataApiService } from '../../services/data/data-api.service';
import { FilterGroupType, RuleOperator } from '@app/modules/core/store/models';
import { Store } from '@ngrx/store';
import { HorizonRatingsFeature } from './horizon-ratings.feature';

export const loadRatingsDocuments = createEffect(
  (actions$ = inject(Actions), dataApi = inject(DataApiService)) =>
    actions$.pipe(
      ofType(HorizonRatingsActions.loadRatingsDocuments),
      switchMap(({ datasetUId, selectedOverviewDocument }) =>
        dataApi
          .getHorizonIntelRatingsDocuments(datasetUId, {
            fields: 'uId,rating_number,rating_text,category_tag,rank,horizon_category_id,horizon_parent_id,intel,custom_rating_number',
            filterGroup: {
              filters: [
                {
                  field: 'location_id',
                  operator: RuleOperator.Equal,
                  value: selectedOverviewDocument.location_id.toString()
                }
              ],
              filterGroups: [],
              groupType: FilterGroupType.And
            },
            pagination: { skip: 0, take: 100000 }
          })
          .pipe(
            map(({ data: ratingsDocuments }) => HorizonRatingsActions.loadRatingsDocumentsSuccess({ ratingsDocuments })),
            catchError(error => of(HorizonRatingsActions.loadRatingsDocumentsError({ error })))
          )
      )
    ),
  { functional: true }
);

export const showExpandedView = createEffect(
  (actions$ = inject(Actions), store = inject(Store)) =>
    actions$.pipe(
      ofType(HorizonRatingsActions.showExpandedView),
      withLatestFrom(store.select(HorizonRatingsFeature.selectHorizonRatingsState)),
      filter(([action, state]) => {
        const hasRatingDocuments = Boolean(state.ratingsDocuments.length);

        return (
          (action.selectedOverviewDocument.uId === state.selectedOverviewDocument.uId && !hasRatingDocuments) ||
          (hasRatingDocuments &&
            state.ratingsDocuments.some(({ location_id }) => location_id !== action.selectedOverviewDocument.location_id)) ||
          action.loadRatingsDocuments
        );
      }),
      switchMap(([{ datasetUId, selectedOverviewDocument }]) =>
        of(HorizonRatingsActions.loadRatingsDocuments({ datasetUId, selectedOverviewDocument }))
      )
    ),
  { functional: true }
);
